import { FC } from "react";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import styles from "./MedicalClaimsPage.module.scss";
import { MedicalClaimsList } from "../../components";

export const MedicalClaimsPage: FC = () => {

  return (
    <div className={styles.MedicalClaimsPanelContainer}>
      <Stack spacing="large">
        <MedicalClaimsList />
      </Stack>
    </div>
  );
};
